import type {
  CompletedSaleTransaction,
  FailedSaleTransaction,
} from '~/api/graphql/generated/types'
import type { InvoiceOrEstimate } from '~/types'

export enum PaymentFlowState {
  RECORD_PAYMENT = 'RECORD_PAYMENT',
  PAYMENT_REQUEST = 'PAYMENT_REQUEST',
  PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
}

export enum PaymentMethod {
  CREDIT_DEBIT = 'CREDIT_DEBIT',
  CARECREDIT = 'CARECREDIT',
  CASH = 'CASH',
  CHECK = 'CHECK',
}

export interface PaymentData {
  accountCreditTotal?: number
  amountReceived?: string
  amountToCharge: string
  authNumber?: string
  changeDue?: string
  checkNumber?: string
  creditCardLastFour?: string
  creditCardType?: string
  invoiceIds?: string[]
  paymentMethod: string
  paymentTerminal: string
  selectedAccountCreditIds?: string[]
  transactionId?: string
}

export interface PaymentDialogContextType {
  actions: {
    cancelTransaction: () => void
    clearPartialPayment: () => void
    clearPaymentData: () => void
    clearPaymentError: () => void
    handleTransactionFailure: (transaction: FailedSaleTransaction) => void
    handleTransactionHardFailure: () => void
    handleTransactionSuccess: (
      currentPaymentData: PaymentData,
      transaction: CompletedSaleTransaction,
    ) => void
    recordPayment: (currentPaymentData: PaymentData) => Promise<void>
    resetDialog: () => void
    sendToTerminal: (currentPaymentData: PaymentData) => Promise<void>
    setPartialPayment: (amount: number) => void
    setPaymentData: (data: PaymentData) => void
    setPaymentError: (error: {
      message: string
      severity: 'error' | 'warning'
      status: number
    }) => void
  }
  businessId: string
  dialogState: PaymentDialogStateType
  invoice: InvoiceOrEstimate
  isButtonActionLoading: boolean
  isEstimate?: boolean
}

export interface PaymentDialogStateType {
  currentState: PaymentFlowState
  hasPartialPayment: boolean
  partialPaymentAmount: number
  paymentData: PaymentData
  paymentError: {
    message: string
    severity: 'error' | 'warning'
    status: number
  } | null
}

export const isTransactionCompleted = (transaction: any): boolean =>
  transaction?.__typename === 'CompletedSaleTransaction'

export const isTransactionError = (transaction: any): boolean =>
  transaction?.__typename === 'FailedSaleTransaction'

export const isTransactionProcessing = (transaction: any): boolean =>
  transaction?.__typename === 'PendingSaleTransaction'
